export class LawAndRegulation {
  lawAndRegulationId?: number;
  clientITProfileId?: number;
  identificationNumber?: string;
  title?: string;
  date?: number;
  link?: number;
}
